module.exports = __webpack_public_path__ + "static/media/loc1_img6.ab3b381c.jpg";